import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryHero from './components/CategoryHero';
import ArticleGrid from './components/ArticleGrid';
import { categoryConfig, categoryArticles, type ArticleItem } from '@/mocks/category';

function getCategoryArticles(slug: string): ArticleItem[] {
  return categoryArticles[slug] || [];
}

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const config = slug ? categoryConfig[slug] : null;
  const articles = slug ? getCategoryArticles(slug) : [];
  const categoryName = config?.name || '分类浏览';

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: categoryName },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${categoryName} - 吃瓜网站线路一`,
            description: config?.description || '浏览最新吃瓜爆料内容',
            url: 'http://kp51.cn/category/all',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网站线路一',
              url: 'http://kp51.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://kp51.cn/' },
                { '@type': 'ListItem', position: 2, name: categoryName, item: 'http://kp51.cn/category/all' },
              ],
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <CategoryHero />
        <div className="bg-background-50">
          <Breadcrumb items={breadcrumbItems} />
          <section className="px-4 md:px-6 py-8 md:py-12">
            {articles.length > 0 ? (
              <ArticleGrid articles={articles} categorySlug={slug || ''} />
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-200">
                  <i className="ri-file-search-line text-3xl text-foreground-400"></i>
                </div>
                <h2 className="text-xl font-semibold text-foreground-700 mb-3">暂无相关内容</h2>
                <p className="text-sm text-foreground-500 mb-6">该分类下暂时没有爆料内容，请稍后再来</p>
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-2.5 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  返回首页看看
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </Link>
              </div>
            )}
          </section>

          {articles.length > 0 && (
            <section className="px-4 md:px-6 pb-12">
              <div className="flex items-center justify-between bg-background-100 rounded-lg px-6 py-4">
                <span className="text-sm text-foreground-500">
                  共 <strong className="text-foreground-950">{articles.length}</strong> 篇爆料内容
                </span>
                <div className="flex items-center gap-2">
                  <button className="w-8 h-8 flex items-center justify-center rounded-md bg-white text-foreground-500 border border-background-200 cursor-pointer hover:bg-background-50 transition-colors" aria-label="上一页" disabled>
                    <i className="ri-arrow-left-s-line text-sm"></i>
                  </button>
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-white text-xs font-semibold cursor-default">1</span>
                  <button className="w-8 h-8 flex items-center justify-center rounded-md bg-white text-foreground-500 border border-background-200 cursor-pointer hover:bg-background-50 transition-colors" aria-label="下一页">
                    <i className="ri-arrow-right-s-line text-sm"></i>
                  </button>
                </div>
              </div>
            </section>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}